var _excluded = ["show"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Div, Heading } from '@kizi/core-components';
import React, { useEffect } from 'react';
import { Portal } from 'react-portal';
import { ScrollbarStyle, cursorPointer } from '../utils/style';
import { IconV2 as Icon } from './IconV2';
var WRAPPER_PADDING = [null, null, 48];

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
      noCloseIcon = _ref.noCloseIcon,
      noHorizontalMargin = _ref.noHorizontalMargin,
      onClose = _ref.onClose,
      title = _ref.title,
      modalContainerDivProps = _ref.modalContainerDivProps;
  var wrapperPx = WRAPPER_PADDING;

  if (noHorizontalMargin) {
    wrapperPx = [0];
  }

  return /*#__PURE__*/React.createElement(Div, _extends({
    bg: "white",
    display: "flex",
    flexDirection: "column",
    mx: "auto",
    maxHeight: "90vh",
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    position: "relative",
    px: wrapperPx,
    py: WRAPPER_PADDING,
    variant: modalContainerDivProps !== null && modalContainerDivProps !== void 0 && modalContainerDivProps.variant ? modalContainerDivProps.variant : 'modalContainer'
  }, modalContainerDivProps), !noCloseIcon && /*#__PURE__*/React.createElement(Div, {
    display: "flex",
    position: "absolute",
    right: "8px",
    top: "8px",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    display: "flex",
    fill: "second.0",
    height: 32,
    width: 32,
    name: "cross-in-circle",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose(e);
    }
  }, cursorPointer))), title && /*#__PURE__*/React.createElement(Div, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: [4, null, 6],
    mt: [2, null, 0],
    mx: "auto",
    px: [4, null, 0],
    variant: "H2",
    textAlign: "center",
    width: ['75%', null, '100%']
  }, title)), /*#__PURE__*/React.createElement(ScrollbarStyle, null), /*#__PURE__*/React.createElement(Div, {
    overflowY: "auto",
    flexGrow: 1,
    minHeight: 0
  }, children));
};

var useBodyScrollLock = function useBodyScrollLock(isLocked) {
  useEffect(function () {
    if (isLocked) {
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      document.body.style.position = 'fixed';
      document.body.style.top = "-".concat(scrollY, "px");
      document.body.style.left = "-".concat(scrollX, "px");
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
      return function () {
        var body = document.body.style;
        body.position = '';
        body.top = '';
        body.left = '';
        body.width = '';
        body.height = '';
        body.overflow = '';
        window.scrollTo(scrollX, scrollY);
      };
    }

    return undefined;
  }, [isLocked]);
};

export function Modal(_ref2) {
  var _ref2$show = _ref2.show,
      show = _ref2$show === void 0 ? false : _ref2$show,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  useBodyScrollLock(show);
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Div, {
    bg: "rgba(0,0,0,.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "data-testid": "modal",
    onClick: restProps['onClose'],
    position: "fixed",
    height: "100vh",
    left: 0,
    top: 0,
    width: "100vw",
    zIndex: 41,
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(ModalContainer, restProps))));
}
export default Modal;